const asRecord = (value: unknown): Record<string, unknown> =>
  value && typeof value === "object" ? value as Record<string, unknown> : {};

const readableMessage = (value: unknown, depth = 0): string | undefined => {
  if (depth > 4 || value === null || value === undefined) return undefined;
  if (typeof value === "string") {
    const text = value.trim();
    if (!text || text.length > 700 || /<[^>]+>|Traceback|sqlalchemy|psycopg2|__c|Network Error|Request failed with status|FETCH_ERROR|TIMEOUT_ERROR/i.test(text)) return undefined;
    return text;
  }
  if (Array.isArray(value)) {
    const messages = value.map((item) => readableMessage(item, depth + 1)).filter(Boolean);
    return messages.length ? messages.join("; ") : undefined;
  }
  if (typeof value !== "object") return undefined;
  const data = asRecord(value);
  return readableMessage(data.message, depth + 1) ?? readableMessage(data.detail, depth + 1) ?? readableMessage(data.msg, depth + 1);
};

/** Read backend/RTK/Axios messages without rendering internal traces or HTML. */
export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  const e = asRecord(error);
  const response = asRecord(e.response);
  const nested = asRecord(e.error);
  const status = Number(e.status ?? response.status ?? nested.status);
  if (status === 401) return "Your session has expired. Please sign in again.";
  if (status === 403) return "You do not have permission to perform this action.";
  if (status === 413) return readableMessage(e.data) ?? readableMessage(response.data) ?? "This file is too large. Please choose a smaller file.";
  if (status === 503) return readableMessage(e.data) ?? readableMessage(response.data) ?? "This service is temporarily unavailable. Please try again shortly.";
  if (status >= 500) return fallback;
  return readableMessage(e.data) ?? readableMessage(nested.data) ?? readableMessage(response.data)
    ?? readableMessage(e.message) ?? readableMessage(typeof error === "string" ? error : undefined) ?? fallback;
};
